/**
 * GLOBAL SAFE WRAPPER - CATCH ALL UNHANDLED PROMISE REJECTIONS
 * 
 * Tự động bắt tất cả lỗi promise chưa được handle để:
 * 1. Ngăn app crash với "[object Object]"
 * 2. Hiển thị thông báo lỗi thân thiện cho user
 * 3. Log lỗi để debug
 * 
 * KHÔNG CẦN thêm try-catch trong component!
 */

import Swal from "sweetalert2";

/**
 * Setup global error handler
 * Gọi 1 lần duy nhất trong index.js
 */
export const setupGlobalErrorHandler = () => {
  // Catch unhandled promise rejection
  window.addEventListener('unhandledrejection', (event) => {
    console.error('[GlobalSafeWrapper] Unhandled promise rejection:', event.reason);
    
    // Ngăn browser hiển thị error mặc định
    event.preventDefault();
    
    // Parse error từ Saga
    const error = event.reason;
    
    if (error && typeof error === 'object') {
      const { status, message, data } = error;
      
      // Hiển thị alert phù hợp với status code
      if (status === 400 || status === 422) {
        // Validation error - Warning
        Swal.fire({
          icon: 'warning',
          title: 'Thông báo',
          text: message || 'Dữ liệu không hợp lệ',
          confirmButtonText: 'Đóng'
        });
      } else if (status === 403) {
        // Forbidden - Error
        Swal.fire({
          icon: 'error',
          title: 'Không có quyền',
          text: message || 'Bạn không có quyền thực hiện thao tác này',
          confirmButtonText: 'Đóng'
        });
      } else if (status === 404) {
        // Not Found - Warning
        Swal.fire({
          icon: 'warning',
          title: 'Không tìm thấy',
          text: message || 'Dữ liệu không tồn tại',
          confirmButtonText: 'Đóng'
        });
      } else if (status === 409) {
        // Conflict - Warning
        Swal.fire({
          icon: 'warning',
          title: 'Xung đột dữ liệu',
          text: message || 'Dữ liệu đã tồn tại hoặc đang được sử dụng',
          confirmButtonText: 'Đóng'
        });
      } else if (status === 500) {
        // Server Error
        Swal.fire({
          icon: 'error',
          title: 'Lỗi hệ thống',
          text: message || 'Đã có lỗi xảy ra, vui lòng thử lại sau',
          confirmButtonText: 'Đóng'
        });
      } else if (message) {
        // Generic error với message
        Swal.fire({
          icon: 'error',
          title: 'Lỗi',
          text: message,
          confirmButtonText: 'Đóng'
        });
      } else {
        // Unknown error
        Swal.fire({
          icon: 'error',
          title: 'Lỗi',
          text: 'Đã có lỗi xảy ra, vui lòng thử lại',
          confirmButtonText: 'Đóng'
        });
      }
      
      // Log chi tiết để debug
      console.error('[GlobalSafeWrapper] Error details:', {
        status,
        message,
        data
      });
    } else {
      // Lỗi không phải từ Saga
      console.error('[GlobalSafeWrapper] Unknown error:', error);
      
      Swal.fire({
        icon: 'error',
        title: 'Lỗi',
        text: 'Đã có lỗi xảy ra, vui lòng thử lại',
        confirmButtonText: 'Đóng'
      });
    }
  });
  
  // Catch global error (fallback)
  window.addEventListener('error', (event) => {
    console.error('[GlobalSafeWrapper] Global error:', event.error);
    
    // Không preventDefault để browser vẫn log error
    // chỉ hiển thị thông báo cho user
    
    if (event.error && event.error.message) {
      // Không hiển thị alert cho lỗi syntax hoặc lỗi code
      // Chỉ log để dev debug
      console.error('[GlobalSafeWrapper] Error message:', event.error.message);
    }
  });
  
  console.log('[GlobalSafeWrapper] ✅ Initialized');
};

/**
 * Manually trigger error handler (for testing)
 */
export const testErrorHandler = () => {
  return Promise.reject({
    status: 500,
    message: 'This is a test error',
    data: null
  });
};
